import { FunctionComponent } from 'react'
import { Breadcrumbs, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface Props {
  items: { title: string; path?: string; id?: string }[]
}

const StyledLink = styled(Link)({
  fontSize: '14px',
  cursor: 'pointer',
  textDecoration: 'none',
  color: '#000',
})

export const BreadCrumb: FunctionComponent<Props> = ({ items }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs
      aria-label="breadcrumbs"
      sx={{
        padding: '8px 0 24px',
        display: { xs: 'none', md: 'block' },
        '& li:last-child': {
          width: '40%',
        },
      }}
    >
      {items.map((item) => {
        return item.path ? (
          <StyledLink key={item.title} color="neutral" to={item.path}>
            {t(item.id ?? item.title)}
          </StyledLink>
        ) : (
          <Typography
            key={item.title}
            sx={{
              color: '#8a94a6',
              fontSize: '14px',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {t(items[items.length - 1].id ?? items[items.length - 1].title)}
          </Typography>
        )
      })}
    </Breadcrumbs>
  )
}
